import axios from "axios";
import moment from "moment";

const state = () => ({
  historicallogs: [],
  pagination: {
    current_page: 1,
    per_page: 10,
    total: 0,
    last_page: 1,
    from: 0,
    to: 0,
  },
  filters: {
    startDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
    search: "",
    sort_by: "time",
    sort_order: "desc",
  },
  loading: false,
});

const mutations = {
  SET_HISTORICAL_LOGS(state, logs) {
    state.historicallogs = logs;
  },

  SET_PAGINATION(state, pagination) {
    state.pagination = { ...state.pagination, ...pagination };
  },

  SET_FILTERS(state, filters) {
    state.filters = { ...state.filters, ...filters };
  },

  SET_LOADING(state, loading) {
    state.loading = loading;
  },

  RESET_FILTERS(state) {
    state.filters = {
      startDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      search: "",
      sort_by: "time",
      sort_order: "desc",
    };
  },
};

const getters = {
  getHistoricalLogs: (state) => {
    return state.historicallogs;
  },

  getPagination: (state) => {
    return state.pagination;
  },

  getFilters: (state) => {
    return state.filters;
  },

  isLoading: (state) => {
    return state.loading;
  },
};

const actions = {
  async fetchHistoricalLogs({ commit, state, dispatch }, params = {}) {
    commit("SET_LOADING", true);

    const baseUrl = process.env.VUE_APP_API_URL + "/devices/historical-logs";

    const apiParams = {
      startDate: state.filters.startDate,
      endDate: state.filters.endDate,
      page: params.current_page || state.pagination.current_page,
      per_page: params.per_page || state.pagination.per_page,
      sort_by: state.filters.sort_by,
      sort_order: state.filters.sort_order,
      search: state.filters.search,
    };

    const apiUrl = buildApiUrl(baseUrl, apiParams);

    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
      },
    };

    try {
      const response = await axios.get(apiUrl, config);

      commit("SET_HISTORICAL_LOGS", response.data.data);
      commit("SET_PAGINATION", {
        current_page: response.data.current_page || 1,
        per_page: response.data.per_page || 10,
        total: response.data.total || 0,
        last_page: response.data.last_page || 1,
        from: response.data.from || 0,
        to: response.data.to || 0,
      });
    } catch (error) {
      dispatch(
        "toastNotification/displayToast",
        {
          message:
            error?.response?.data?.message || "Failed to fetch historical logs",
          type: "warning",
        },
        { root: true }
      );
      console.error("Error fetching historical logs:", error);
    } finally {
      commit("SET_LOADING", false);
    }
  },

  setFilters({ commit }, filters) {
    commit("SET_FILTERS", filters);
  },

  setPagination({ commit }, pagination) {
    commit("SET_PAGINATION", pagination);
  },

  resetHistoricalLogs({ commit }) {
    commit("SET_HISTORICAL_LOGS", []);
    commit("RESET_FILTERS");
    commit("SET_PAGINATION", {
      current_page: 1,
      per_page: 10,
      total: 0,
      last_page: 1,
      from: 0,
      to: 0,
    });
  },
};

const buildApiUrl = (baseUrl, params) => {
  const cleanParams = {};

  Object.entries(params).forEach(([key, value]) => {
    if (value != null && value !== "") {
      cleanParams[key] = value;
    }
  });

  const searchParams = new URLSearchParams(cleanParams);

  return `${baseUrl}?${searchParams.toString()}`;
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
